import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _SpecifiedAnswers;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import partial from 'lodash/partial';
import isArray from 'lodash/isArray';
import { jsx } from '@instructure/emotion';
import { View } from '@instructure/ui-view';
import Errors from '../../../../../common/edit/components/Errors';
import Footer from '../../../../../common/edit/components/Footer';
import { toErrors } from '../../../../../../util/instUIMessages';
import t from '@instructure/quiz-i18n/es/format-message';
import { TextInput, FormFieldGroup, Flex } from '@instructure/quiz-common';
import RemoveChoiceButton from '../../../../../common/edit/components/RemoveChoiceButton';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
var SpecifiedAnswers = /*#__PURE__*/function (_Component) {
  function SpecifiedAnswers() {
    var _this;
    _classCallCheck(this, SpecifiedAnswers);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SpecifiedAnswers, [].concat(args));
    _defineProperty(_this, "_timeouts", []);
    _defineProperty(_this, "updateSpecifiedAnswer", function (index, e) {
      var newSDVal = update(_this.__safeScoringDataValue(), _defineProperty({}, index, {
        $set: e.target.value
      }));
      _this.__updateScoringData(newSDVal);
    });
    _defineProperty(_this, "setInputRef", function (index) {
      return function (node) {
        _this["input_".concat(index)] = node;
      };
    });
    _defineProperty(_this, "setRemoveRef", function (index) {
      return function (node) {
        _this["remove_".concat(index)] = node;
      };
    });
    _defineProperty(_this, "addSpecifiedAnswer", function () {
      _this.__updateScoringData(_this.__safeScoringDataValue().concat(''));
      _this.props.notifyScreenreader(t('Added specified answer.'));
      _this._timeouts = [].concat(_toConsumableArray(_this._timeouts), [setTimeout(function () {
        var lastInputIndex = _this.__safeScoringDataValue().length - 1;
        _this["input_".concat(lastInputIndex)].focus();
      })]);
    });
    _defineProperty(_this, "removeSpecifiedAnswer", function (index, e) {
      var newSDVal = update(_this.__safeScoringDataValue(), {
        $splice: [[index, 1]]
      });
      _this.__updateScoringData(newSDVal);
      _this.props.notifyScreenreader(t('Removed specified answer.'));
      _this._timeouts = [].concat(_toConsumableArray(_this._timeouts), [setTimeout(function () {
        var valLength = _this.__safeScoringDataValue().length;
        if (valLength === 1) {
          _this["input_".concat(0)].focus();
        } else if (valLength === index) {
          _this["remove_".concat(index - 1)].focus();
        } else {
          _this["remove_".concat(index)].focus();
        }
      })]);
    });
    return _this;
  }
  _inherits(SpecifiedAnswers, _Component);
  return _createClass(SpecifiedAnswers, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._timeouts.forEach(clearTimeout);
    }
  }, {
    key: "__safeScoringDataValue",
    value: function __safeScoringDataValue() {
      return isArray(this.props.scoringDataForBlank.value) ? this.props.scoringDataForBlank.value : [];
    }
  }, {
    key: "__updateScoringData",
    value: function __updateScoringData(value) {
      this.props.updateScoringDataForBlank({
        scoringData: {
          value: value,
          blankText: value[0]
        }
      });
    }
  }, {
    key: "renderRemoveAnswerButton",
    value:
    // === Rendering ===

    function renderRemoveAnswerButton(index, onlyAnswer, answer) {
      if (!onlyAnswer) {
        return jsx(RemoveChoiceButton, {
          ref: this.setRemoveRef(index),
          choiceId: index,
          screenReaderText: t('Remove Answer: {answer}', {
            answer: answer
          }),
          onRemoveChoice: this.removeSpecifiedAnswer,
          padding: "0"
        });
      }
    }
  }, {
    key: "renderAnswer",
    value: function renderAnswer(answer, index, onlyAnswer) {
      return jsx(Flex, {
        direction: "row",
        key: index,
        gap: "small",
        alignItems: "start"
      }, jsx(Flex.Item, {
        shouldGrow: true
      }, jsx(TextInput, {
        messages: toErrors(this.props.errors[index] || []),
        defaultValue: answer,
        inputRef: this.setInputRef(index),
        renderLabel: t('Answer'),
        isRequired: true,
        onChange: partial(this.updateSpecifiedAnswer, index)
      })), jsx(Flex.Item, null, jsx(View, {
        as: "div",
        margin: "xx-large 0 0 0",
        themeOverride: {
          marginXxLarge: '30px'
        }
      }, this.renderRemoveAnswerButton(index, onlyAnswer, answer))));
    }
  }, {
    key: "renderSpecifiedAnswers",
    value: function renderSpecifiedAnswers() {
      var _this2 = this;
      var specifiedAnswers = this.__safeScoringDataValue();
      var onlyAnswer = specifiedAnswers.length === 1;
      return specifiedAnswers.map(function (answer, index) {
        return _this2.renderAnswer(answer, index, onlyAnswer);
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Errors, {
        errorList: this.props.errors.$errors || [],
        isGroupError: true,
        showBorder: false,
        errorsFirst: false
      }, jsx(View, {
        as: "div",
        margin: "small 0 0 0"
      }, jsx(FormFieldGroup, {
        rowSpacing: "none",
        description: jsx(ScreenReaderContent, null, t('Correct Answers'))
      }, jsx(Flex, {
        width: "100%",
        direction: "column",
        gap: "small"
      }, this.renderSpecifiedAnswers())), jsx(Footer, {
        onCreateChoice: this.addSpecifiedAnswer,
        notifyScreenreader: this.props.notifyScreenreader
      })));
    }
  }]);
}(Component);
_SpecifiedAnswers = SpecifiedAnswers;
_defineProperty(SpecifiedAnswers, "displayName", 'SpecifiedAnswers');
_defineProperty(SpecifiedAnswers, "componentId", "Quizzes".concat(_SpecifiedAnswers.displayName));
// =============
//   CONFIG
// =============
_defineProperty(SpecifiedAnswers, "propTypes", {
  errors: PropTypes.object.isRequired,
  notifyScreenreader: PropTypes.func.isRequired,
  scoringDataForBlank: PropTypes.object.isRequired,
  updateScoringDataForBlank: PropTypes.func.isRequired,
  styles: PropTypes.object
});
export { SpecifiedAnswers as default };